import { useCallback, useEffect, useState } from "react";
import Particles from "react-tsparticles";
import BannerText from "./BannerText";
import SocialLinks from "./SocialLinks";
import TsParticles from "./TsParticles";
import Navigation from "./Navigation";

export default function Banner() {
  return (
    <section className="main-container">
      <section className="banner">
        <TsParticles />
        <img src={require("../images/banner1.jpg")} alt="" />
        <div className="container">
          <BannerText />
          <SocialLinks />
        </div>
      </section>
      <Navigation />
    </section>
  );
}
